module.exports = __webpack_public_path__ + "static/media/mvp_announcement.4cc1f25e.jpg";